var $443fd9a1fd169eb8$exports = {};
$443fd9a1fd169eb8$exports = {
    "endTime": `Biti\u{15F} saati`,
    "startTime": `Ba\u{15F}lang\u{131}\xe7 saati`,
    "time": `Saat`
};


export {$443fd9a1fd169eb8$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
